import { Shape } from 'three';

export class TriangleShape extends Shape {
  constructor(width: number, height: number) {
    super();

    this.moveTo(-width / 2, -height / 2)
      .lineTo(width / 2, -height / 2)
      .lineTo(0, height / 2)
      .lineTo(-width / 2, -height / 2);
  }
}

export default TriangleShape;
